import {cn} from "@/lib/utils.ts";
import {Outlet} from "react-router";

export default function AuthLayout({children, className, ...props}: React.ComponentProps<"div">) {
    return (
        <div
            className={cn("bg-muted flex min-h-svh flex-col items-center justify-center p-6 md:p-10", className)} {...props}>
            <div className="w-full max-w-sm md:max-w-3xl">
                <Outlet/>
            </div>
        </div>
    )
}